import {
  Defaults,
  Traits,
} from './shared';

import { ICON_BUTTON_CHAT } from './../../../const/icons';

import { COMP_BUTTON_CHAT } from './../../../const/components';

import { FIELD_CHAT_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const Chat = (editor, options:any = {}) => {

  (FIELD_CHAT_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_CHAT,
    displayIcon: ICON_BUTTON_CHAT,
    model: {
      defaults: { ...Defaults,
        name: 'Chat',
        traits: [ ...Traits, FIELD_CHAT_SELECTOR]
      }
    }
  });
}